<template>
<div class="fields-grey-wrapper text-center">
    <a href="#" class=" text-400">
        <i class="pi pi-cloud-upload text-7xl p-5"></i>
        <p>CARICA UN FILE</p>
    </a>

</div>
<Button label="SALVA MODIFICHE" class="p-button-rounded mt-4" />
</template>
<script>
import Button from 'primevue/button';
export default {
    components: {
       Button
    },
    data() {
		return {

		}
	}
}
</script>
